import { useEffect, useState } from 'react';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa6';
import ChangePasswordPanel from './ChangePasswordPanel';
import { useAuth } from '../../../Providers/AuthProvider';
import LoadingSpinner from '../../Components/LoadingSpinner';

const PasswordChangeCard = ({ user }) => {
    const { handleGetUserPassword } = useAuth()
    const [isChangePasswordVisible, setIsChangePasswordVisible] = useState(false);
    const [isPasswordVisible, setIsPasswordVivible] = useState(false);
    const [userPassword, setUserPassword] = useState('')
    const [isPasswordLoading, setIsPasswordLoading] = useState(false)

    const handleChangePasswordButtonClick = () => {
        setIsChangePasswordVisible(true);
    }

    const togglePasswordVisibility = async () => {
        setIsPasswordVivible(!isPasswordVisible);
    }

    useEffect(() => {
        const getUserPassword = async () => {
            if (userPassword.trim() == '' && isPasswordVisible) {
                setIsPasswordLoading(true)
                let password = await handleGetUserPassword()
                setUserPassword(password)
                setIsPasswordLoading(false)
            }
        }
        getUserPassword()
    }, [isPasswordVisible])

    return (
        <div>
            <div className='row justify-content-center mt-2'>
                <div className='justify-content-center'>
                    <div>
                        <ChangePasswordPanel user={user} isChangePasswordVisible={isChangePasswordVisible} setIsChangePasswordVisible={setIsChangePasswordVisible} />
                        <div className='panel-header-title'>Twoje hasło</div>
                        <div className='col-auto ms-1'>
                            <span>Aktualne hasło:</span>
                            {isPasswordLoading ? (<div className='d-flex me-0 ms-2'>
                                <LoadingSpinner width={2} height={2} />
                            </div>)
                                :
                                (
                                    <div className='d-flex align-items-center'>
                                        <span style={{ fontWeight: 'bold', fontSize: '25px' }}>
                                            {isPasswordVisible ? userPassword : '*'.repeat(5)}
                                        </span>
                                        <button className='ms-2 ' style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }} onClick={togglePasswordVisibility}>
                                            {isPasswordVisible ? <FaRegEyeSlash className='primary-accent-color-text' /> : <FaRegEye className='primary-accent-color-text' />}
                                        </button>
                                    </div>
                                )}

                        </div>
                        <button className='btn-app-secondary mt-3' onClick={handleChangePasswordButtonClick}>
                            Zmień hasło
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default PasswordChangeCard;